// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1OwjG","rootSmall":"AddTileButton_rootSmall__1cGvy"};